import axios from 'axios';
import { deleteRequest, patch } from 'helpers/api';
import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

export function save(basePath, configurableEnum) {
  let method, path;
  if (configurableEnum.id) {
    path = `${basePath}/${configurableEnum.id}`;
    method = 'put';
  } else {
    path = basePath;
    method = 'post';
  }

  return axios[method](path, snakecaseKeys({ configurableEnum }))
    .then((response) => {
      return camelcaseKeys(response.data, { deep: true });
    })
    .catch((error) => {
      throw error.response.data.errors || ['Something went wrong'];
    });
}

export function remove(basePath, enumId, updateEnumId) {
  return deleteRequest(`${basePath}/${enumId}?update_enum_id=${updateEnumId}`);
}

export function reorder(basePath, configurableEnums) {
  configurableEnums = configurableEnums.map((e, index) => {
    return {
      id: e.id,
      sortOrder: index
    };
  });

  patch(basePath, { configurableEnums });
}
